import { ghqSearchParseQueryId } from './utils';
const $ = jQuery;

class GutenberghubQueryFilterSearch {
	/**
	 * Constructor.
	 *
	 * @param {HTMLFormElement} blockElement
	 * @param {HTMLDivElement} queryLoopBlockElement
	 */
	constructor( blockElement, queryLoopBlockElement, queryBlockIndex ) {
		this.blockElement = blockElement;
		this.queryLoopBlockElement = queryLoopBlockElement;
		this.queryBlockIndex = queryBlockIndex;
		this.postTemplate = $( this.queryLoopBlockElement ).find(
			'.wp-block-post-template'
		);
		this.loadMoreButton = $( this.queryLoopBlockElement ).find(
			'.ghub-query-load-more'
		);
		this.resultCount = $( this.queryLoopBlockElement ).find(
			'.gutenberghub-query-result-count'
		);
		/**
		 * Query Identity.
		 *
		 * @type {number}
		 */
		this.queryId = ghqSearchParseQueryId( queryLoopBlockElement );

		/**
		 * @type {HTMLInputElement|null} Search input.
		 */
		this.searchInput = this.blockElement.querySelector(
			'input[type="search"]'
		);

		this.initialize();
	}

	/**
	 * Initializes the search control.
	 *
	 * @return {void}
	 */
	initialize() {
		/**
		 * Removing the default required attribute.
		 */
		this.searchInput?.removeAttribute( 'required' );

		/**
		 * Adding default value.
		 */
		const currentSearchQuery = new URLSearchParams( location.search );

		if ( currentSearchQuery.has( 'qid' ) ) {
			const isCurrentDefaultSearch =
				currentSearchQuery.get( 'qid' ) === this.queryId.toString();

			if ( isCurrentDefaultSearch ) {
				this.searchInput.value = currentSearchQuery.get( 'qs' );
			}
		}

		this.preventDefaultSubmission();
		this.handleSubmission();
	}

	/**
	 * Handles the load more visibility.
	 *
	 * @param {HTMLElement} newPostWrapper Next page query loop instance
	 */
	handleLoadMoreButton( newPostWrapper ) {
		if ( this.loadMoreButton.get( 0 ) === undefined ) {
			return null;
		}
		const newLoadMoreButton = $( newPostWrapper ).find(
			'.ghub-query-load-more'
		);
		const newLoadMoreTotalPages = newLoadMoreButton.data( 'totalpages' );
		this.loadMoreButton.attr( 'data-totalpages', newLoadMoreTotalPages );
		newLoadMoreTotalPages === 1 || newLoadMoreTotalPages === 0
			? this.loadMoreButton.css( 'display', 'none' )
			: this.loadMoreButton.css( 'display', 'flex' );
	}
	/**
	 * Handles the result count.
	 *
	 * @param {HTMLElement} newPostWrapper Next page query loop instance
	 */
	handleResultCount( newPostWrapper ) {
		if ( this.resultCount.get( 0 ) === undefined ) {
			return null;
		}
		const newResultCount = $( newPostWrapper ).find(
			'.gutenberghub-query-result-count'
		);
		this.resultCount.replaceWith( newResultCount );
		this.resultCount = newResultCount;
	}

	/**
	 * Loads the requested query.
	 *
	 * @param {{
	 *  search: string;
	 * }} query
	 *
	 * @return {void}
	 */
	loadQuery( query ) {
		const url = new URL( location.href );
		url.searchParams.set( 'qs', query.search );
		url.searchParams.set( 'qid', this.queryId.toString() );

		const self = this;

		$.ajax( {
			url: url.href,
			success: function ( response ) {
				const responseDocument = $( $.parseHTML( response ) );
				const newPostWrapper = responseDocument.find(
					`.wp-block-query`
				)[ self.queryBlockIndex ];
				const newPosts = $( newPostWrapper ).find(
					`.wp-block-post-template .wp-block-post`
				);

				self.handleLoadMoreButton( newPostWrapper );
				self.handleResultCount( newPostWrapper );
				self.postTemplate.html( newPosts );
			},
		} );
		window.history.pushState( {}, '', decodeURIComponent( url ) );
	}

	/**
	 * Removes the search query.
	 *
	 * @return {void}
	 */
	removeQuery( query ) {
		const url = new URL( location.href );
		url.searchParams.delete( 'qs' );
		const self = this;

		$.ajax( {
			url: url.href,
			success: function ( response ) {
				const responseDocument = $( $.parseHTML( response ) );
				const newPostWrapper = responseDocument.find(
					`.wp-block-query`
				)[ self.queryBlockIndex ];

				const newPosts = $( newPostWrapper ).find(
					`.wp-block-post-template .wp-block-post`
				);

				self.handleLoadMoreButton( newPostWrapper );
				self.handleResultCount( newPostWrapper );
				self.postTemplate.html( newPosts );
			},
		} );
		window.history.pushState( {}, '', decodeURIComponent( url ) );
	}

	/**
	 * Obtains the current search query.
	 *
	 * @return {string} Searched query.
	 */
	getSearchQuery() {
		return this.searchInput?.value ?? '';
	}

	/**
	 * Handles the form ajax submission.
	 */
	handleSubmission() {
		this.blockElement.addEventListener( 'submit', ( event ) => {
			const searchQuery = this.getSearchQuery();
			const hasSearchQuery = searchQuery.trim() !== '';

			hasSearchQuery
				? this.loadQuery( { search: searchQuery } )
				: this.removeQuery();
		} );
	}

	/**
	 * Prevents the default core search submission.
	 */
	preventDefaultSubmission() {
		this.blockElement.addEventListener( 'submit', ( event ) => {
			event.preventDefault();
		} );
	}
}

window.addEventListener( 'load', () => {
	/**
	 * @type {NodeListOf<HTMLDivElement>} Loop Blocks.
	 */
	const queryLoopBlocks = document.querySelectorAll( '.wp-block-query' );

	queryLoopBlocks.forEach( ( queryLoopBlock, queryBlockIndex ) => {
		/**
		 * @type {NodeListOf<HTMLFormElement>} Search forms.
		 */
		const searchBlocks = queryLoopBlock.querySelectorAll(
			'.ghub-query-search'
		);

		if ( searchBlocks.length === 0 ) {
			return;
		}

		searchBlocks.forEach( ( searchBlock ) => {
			new GutenberghubQueryFilterSearch(
				searchBlock,
				queryLoopBlock,
				queryBlockIndex
			);
		} );
	} );
} );
